import {isChooseMultipleSeatsMode, isChooseSeatMode} from '../../../../../selectors/navigation'
import {getPlaceDonationError} from '../../../../../selectors/seating/errors'
import {isInAccessibilityMode, isInMobileBasket} from '../../../../../selectors/seating/mode'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {TicketDonationOwnProps, TicketDonationRuntimeProps} from './interfaces'
import {TicketDonation as Presentation} from './ticket-donation'

const mapRuntime = (
  {state, actions: {addPlaceDonation, setPlaceDonationError}}: DetailsPageAppProps,
  {place}: TicketDonationOwnProps,
): TicketDonationRuntimeProps => ({
  error: getPlaceDonationError(state, place.id),
  showAccessibilityMode: isInAccessibilityMode(state),
  chooseSeatMode: isChooseSeatMode(state),
  chooseMultipleSeatsMode: isChooseMultipleSeatsMode(state),
  addPlaceDonation,
  setPlaceDonationError,
  placeKey: `${place.id} ${isInAccessibilityMode(state)} ${isInMobileBasket(state)}`,
})

export const TicketDonation = connect<TicketDonationOwnProps, TicketDonationRuntimeProps>(mapRuntime)(Presentation)
